export default __webpack_public_path__ + "static/media/postcode-api.574cae3b.svg";